export const VALID_CACHED_DAYS = 6;
export const MIN_PLAYERS = 4;
export const NAME_KEYWORD = '@Nombre';
export const MAX_PLAYERS = 15;
export const PHONE_WIDTH = 576;
export const WEB_URL = 'drunkevolution.com';
export const COVID = false;